var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-carousel",
        {
          staticStyle: { "text-shadow": "1px 1px 2px #333" },
          attrs: {
            id: "carousel",
            background: "#ababab",
            interval: 4000,
            "img-width": "1024",
            "img-height": "480"
          }
        },
        [
          _c("b-carousel-slide", {
            attrs: { "img-src": this.getIllu("illu_01") }
          }),
          _vm._v(" "),
          _c("b-carousel-slide", {
            attrs: { "img-src": this.getIllu("illu_02") }
          }),
          _vm._v(" "),
          _c("b-carousel-slide", {
            attrs: { "img-src": this.getIllu("illu_03") }
          }),
          _vm._v(" "),
          _c("b-carousel-slide", {
            attrs: { "img-src": this.getIllu("illu_04") }
          }),
          _vm._v(" "),
          _c("b-carousel-slide", {
            attrs: { "img-src": this.getIllu("illu_05") }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-225a4b3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225a4b3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JumbotronComponent.vue
// module id = null
// module chunks = 